// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
import { toastr } from 'react-redux-toastr';
import { post } from '../../shared/http/request';

/** ************************
 * FileUpload bundle
 ************************ */

// Actions
const FILE_UPLOAD_PENDING = 'FILE_UPLOAD_PENDING';
const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
const FILE_UPLOAD_REJECTED = 'FILE_UPLOAD_REJECTED';

// Reducer
const DEFAULT_STATE = {};
export default function reducer(state = DEFAULT_STATE, action = {}) {
    switch (action.type) {
        case FILE_UPLOAD_PENDING:
            return Object.assign({}, state, { isPending: true, error: null });
        case FILE_UPLOAD_REJECTED:
            return Object.assign({}, state, {
                isPending: false,
                error: action.error,
            });
        case FILE_UPLOAD_SUCCESS:
            return Object.assign({}, state, {
                isPending: false,
            });
        default:
            return state;
    }
}

export const isUploadPending = state => state.fileUpload.isPending;
export const hasError = state => state.fileUpload.error;

// Action Creators/Thunks
export function doFileUpload(data) {
    return function(dispatch) {
        dispatch({ type: FILE_UPLOAD_PENDING });

        return post(data.url, data.formData, true).then(
            response => dispatch({ type: FILE_UPLOAD_SUCCESS }),
            error => {
                toastr.error(error.message, { timeOut: 10000 });
                return dispatch({
                    type: FILE_UPLOAD_REJECTED,
                    error: error.message,
                });
            }
        );
    };
}
